import { useBrowsingHistory } from '@/hooks/useBrowsingHistory';
import { Button, Stack, Typography } from '@mui/material';
import { ArrowLeftIcon } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';
import { NotFoundImage } from './NotFoundImage';

export const NotFoundOrError = () => {
  const { t } = useTranslation();
  const { goBack } = useBrowsingHistory();

  return (
    <Stack alignItems="center" justifyContent="center" flexGrow={1}>
      <Stack alignItems="center" justifyContent="center" width="100%" gap={6}>
        <NotFoundImage />
        <Stack gap={3} alignItems="center" justifyContent="center" width="100%">
          <Stack gap={2} textAlign="center">
            <Typography variant="h3">{t('something_went_wrong')}</Typography>
            <Typography variant="body1">
              {t(
                'the_page_doesnt_exist_or_you_might_not_have_permission_to_access_it'
              )}
            </Typography>
          </Stack>
          <Stack
            direction={{ sm: 'row' }}
            gap={2}
            width="100%"
            justifyContent="center">
            <Button
              size="large"
              variant="contained"
              startIcon={<ArrowLeftIcon />}
              onClick={goBack}>
              {t('go_back')}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              href={'mailto:support@treyd.io'}
              size="large">
              {t('talk_to_support')}
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
